module.exports = __webpack_public_path__ + "static/media/PortfolioPrint.129cdbc4.jpg";